export default __webpack_public_path__ + "static/media/AUSTRIA.7f886c8c.png";